<template>
    <v-btn @click="dialog = true" class="aqua-teal pure-white mx-2">Select Date</v-btn>
    <v-dialog v-model="dialog" width="auto">
        <v-date-picker
          v-if="hasAllowedDates"
          v-model="currentDate"
          color="aqua-teal"
          :allowed-dates="allowedDates"
          :min="minDate"
        ></v-date-picker>
        <v-date-picker
          v-else
          v-model="currentDate"
          color="aqua-teal"
          :min="minDate"
        ></v-date-picker>
    </v-dialog>
</template>

<script>

export default {
    name: "DatePickerDialog",
    data () {
      return {
        dialog: false,
        currentDate: new Date(),
        today: new Date(),
        minDate: "2020-01-01",
      }
    },
    methods: {
        parseMonth: val => {
            if (Number.isInteger(val)){
                const months = [
                "January", "February", "March", "April", "May", 
                "June", "July", "August", "September", "October", 
                "November", "December"];

                return months[val];
            }
        }, 
        parseDate(){
            const date = this.currentDate
            const day = date.getDate() 
            const month = date.getMonth()
            const year = date.getFullYear()
            return `${this.parseMonth(month)} ${day}, ${year}`
        },
        closeDialog(){
            this.dialog = false;
        },
        updateDate(newValue){
            this.$emit('update:date', newValue);
            this.closeDialog()
        }
    },
    props: {
        'date': Date,
        'allowedDates': Array
    },
    emits: ['update:date'],
    computed: {
        hasAllowedDates(){
            return (this.allowedDates) ? true : false; 
        },
        getAllowedDates(){
            if (this.allowedDates){
                return this.allowedDates; 
            } else return []; 
        }
    },
    watch: {
        currentDate(){
            this.updateDate(this.currentDate)
        },
        date(){
            if (this.date){
                this.currentDate = this.date;
            }
        }
    }
}
</script>

<style scoped>
* {
  font-family: 'Montserrat';
}

.aqua-teal {
    background-color: #08B6AA;
}

.pure-white {
  color: #ffffff;
}
</style>
